import WithDirection from '@app/settings/withDirection';
import { AutoComplete } from 'antd';
import { AntAutoComplete } from './styles/autoComplete.style';

const WDAutoCompletes = AntAutoComplete(AutoComplete);

export const IsoAutoComplete = WithDirection(WDAutoCompletes);
export const IsoAutoCompleteOption = AutoComplete.Option;

